// removed by extract-text-webpack-plugin
module.exports = {"iconContainer":"style__iconContainer___A6qRj","infoIcon":"style__infoIcon___1iFBq","infoIconMobile":"style__infoIconMobile___mEYzF","infoIconLarge":"style__infoIconLarge___s5n0f","informationBubble":"style__informationBubble___bS4HH","informationBubbleMobile":"style__informationBubbleMobile___3GriZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/information/style.css
// module id = 602
// module chunks = 0